import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../../config/api";
import { BackEndRoutes } from "../../config/back-end-routes";
import { toast } from "react-toastify";
import { Form, Button, Spinner, Row, Col } from "react-bootstrap";
import DefaultGrid from "../../Components/Default/DefaultGrid";
import { useFilters } from "../../Components/Filters/UseFilter";
import {FrontEndRoutes} from "../../config/front-end-routes";

const PageProduto: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const [productLoading, setProductLoading] = useState(true); // Carregamento inicial
    const [product, setProduct] = useState<any>(null); // Dados do produto
    const { filters, handleFilterChange } = useFilters([]);
    const { id } = useParams<{ id: string }>(); // Obter ID da URL
    const navigate = useNavigate();

    const [productData, setProductData] = useState({
        descricao: "",
        grupo: "",
        cor: "",
        modelo: "",
        unidade: "",
        genero: "",
        estoque: "0",
        status: 1,
    });

    useEffect(() => {
        const fetchProduct = async () => {
            setProductLoading(true);
            try {
                const response = await api.get(BackEndRoutes.routes.PRODUTOS.FIND.replace(":id", id!));
                const product = response.data;
                setProduct(product); // Atualizar o estado do produto
                setProductData({
                    descricao: product.descricao || "",
                    grupo: product.grupo || "",
                    cor: product.cor || "",
                    modelo: product.modelo || "",
                    unidade: product.unidade || "",
                    genero: product.genero || "",
                    estoque: product.estoque || "0",
                    status: product.status,
                });
            } catch (error) {
                toast.error("Erro ao carregar os dados do produto.");
                navigate(FrontEndRoutes.PRODUTOS.LIST); // Redirecionar em caso de erro
            } finally {
                setProductLoading(false);
            }
        };

        if (id) {
            fetchProduct();
        }
    }, [id, navigate]);

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setProductData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        setLoading(true);
        try {
            if (id) {
                await api.put(
                    BackEndRoutes.routes.PRODUTOS.EDIT.replace(":id", id),
                    productData
                );
                toast.success("Produto atualizado com sucesso!");
            } else {
                await api.post(BackEndRoutes.routes.PRODUTOS.CREATE, productData);
                toast.success("Produto criado com sucesso!");
            }
            navigate(FrontEndRoutes.PRODUTOS.LIST);
        } catch (error) {
            toast.error("Erro ao salvar produto.");
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        { key: "id_tabela", label: "ID Tabela", width: 100 },
        { key: "tamanho", label: "Tamanho", width: 100 },
        { key: "ord", label: "Ordem", width: 100 },
        { key: "preco_venda", label: "Preço de Venda", width: 150 },
        { key: "codigo_barras", label: "Código de Barras", width: 200 },
        { key: "quant_pac", label: "Quantidade Pacote", width: 150 },
        { key: "preco_pac", label: "Preço Pacote", width: 150 },
    ];

    return (
        <div className="container-fluid card mt-4">
            <div className="mb-4">
                <h4>Dados do produto</h4>
            </div>
            <div className="mb-4 border-bottom">
                <Form onSubmit={handleSubmit}>
                    <Row className="mb-3">
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Descrição</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="descricao"
                                    value={productData.descricao}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Grupo</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="grupo"
                                    value={productData.grupo}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Cor</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="cor"
                                    value={productData.cor}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Modelo</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="modelo"
                                    value={productData.modelo}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Unidade</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="unidade"
                                    value={productData.unidade}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Gênero</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="genero"
                                    value={productData.genero}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Estoque</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="estoque"
                                    value={productData.estoque}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Status</Form.Label>
                                <Form.Select
                                    name="status"
                                    value={productData.status}
                                    onChange={handleChange}
                                >
                                    <option value={1}>Ativo</option>
                                    <option value={0}>Inativo</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>

                    <div className="d-flex justify-content-end">
                        <Button variant="secondary" className="me-2" onClick={() => navigate(FrontEndRoutes.PRODUTOS.LIST)}
                                disabled={loading}>
                            Cancelar
                        </Button>
                        <Button variant="primary" type="submit" disabled={loading}>
                            {loading ? <Spinner animation="border" size="sm"/> : "Salvar"}
                        </Button>
                    </div>
                </Form>

            </div>

            {product?.precos?.length > 0 ? (
                <div className="mt-4">
                    <h5>Lista de Preços</h5>
                    <DefaultGrid
                        title="Lista de Preços do Produto"
                        columns={columns}
                        filters={filters}
                        handleFilterChange={handleFilterChange}
                        items={product.precos}
                        itemsPerPage={10}
                        loading={loading}
                        onAdd={() => console.log("Adicionar preço")}
                        onEdit={(item: any) => console.log("Editar preço:", item)}
                        onDelete={(item: any) => console.log("Deletar preço:", item)}
                    />
                </div>
            ) : (
                <p className="text-muted">Nenhum preço encontrado para este produto.</p>
            )}
        </div>
    );
};

export default PageProduto;
